// .custom-page-content {
//   .emerald-tabs {
//     background-color: white;
//     .emerald-tab {
//       text-align: left;
//     }
//   }
// }
import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    /* Styles for All Projects Page */
    customPageContent: {
      height: '100%',
      '& div[class*="emerald-tabs"]': {
        backgroundColor: 'white',
        '& div[class*="mdc-tab-bar"]': {
          display: 'block !important',
          maxHeight: '600px',
          overflow: 'auto',
        },
        '& button[class*="mdc-tab"]': {
          justifyContent: 'left !important',
        },
      },
      '& div[class*="emerald-progress-bar"]': {
        background: 'white',
      },
      // '& div[class*="display-content"]': {
      //   display: 'flex',
      //   height: '100%',
      //   gap: '15px',
      //   minHeight: '450px',
      //   paddingBottom: '25px',
      //   background: 'white',
      //   color: 'black',
      //   '& div[class*="code-container"]': {
      //     flex: 1,
      //     paddingLeft: '15px',
      //     paddingRight: '15px',
      //     backgroundColor: 'white',
      //     overflow: 'auto',
      //   },
      //   '& div[class*="code-container"]>div': {
      //     maxHeight: '600px',
      //     margin: '0px',
      //   },
      // },

      // '& div[class*="framework-details-select"]': {
      // width: '100%',
      // paddingTop: '20px',
      // paddingBottom: '20px',
      // background: 'white',
      // paddingLeft: '15px',
      // paddingRight: '15px',
      // display: 'flex',
      // gap: '15px',
      // alignItems: 'center',
      // '& div[class*="emerald-dropdown"]': {
      //   width: '180px',
      // },
      // },

      '& ul[class*="file-tree"]': {
        listStyleType: 'none',
        paddingLeft: '5px',
        overflow: 'auto',
        width: '250px',
        maxHeight: 'calc(100% - 40px)',
        '& ul': {
          listStyleType: 'none',
          paddingLeft: '5px',
        },
        '& ul[class*="show-content"]': {
          display: 'block',
        },
        '& ul[class*="hide-content"]': {
          display: 'none',
        },
        '& li': {
          margin: '5px 0',
        },
        '& .folder': {
          fontWeight: 'bold',
          cursor: 'pointer',
          padding: '2px 5px',
        },
        '& .file': {
          cursor: 'pointer',
          padding: '2px 5px',
        },
        '& .file:hover': {
          background: '#ccc',
        },
        '& .folder:hover': {
          background: '#ccc',
        },
        '& .file.selected': {
          background: '#ccc',
        },
        '& .folder::before': {
          content: '"📁 "',
        },
        '& .folder.open::before': {
          content: '"📂 "',
        },
        '& .file::before': {
          content: '"📄 "',
          width: '15px',
          height: '14px',
          display: 'inline-block',
          paddingRight: '2px',
        },
        '& .file.ts::before': {
          content: `url('https://raw.githubusercontent.com/vscode-icons/vscode-icons/refs/heads/master/icons/file_type_typescript.svg')`,
        },
        '& .file.spec::before': {
          content: `url('https://raw.githubusercontent.com/vscode-icons/vscode-icons/refs/heads/master/icons/file_type_typescriptdef.svg')`,
        },
        '& .file.html::before': {
          content: `url('https://raw.githubusercontent.com/vscode-icons/vscode-icons/refs/heads/master/icons/file_type_html.svg')`,
        },
        '& .file.scss::before': {
          content: `url('https://raw.githubusercontent.com/vscode-icons/vscode-icons/refs/heads/master/icons/file_type_scss.svg')`,
        },
        '& .file.css::before': {
          content: `url('https://raw.githubusercontent.com/vscode-icons/vscode-icons/refs/heads/master/icons/file_type_css2.svg')`,
        },
        '& .file.tsx::before': {
          content: `url('https://raw.githubusercontent.com/vscode-icons/vscode-icons/master/icons/file_type_reactts.svg')`,
        },
        '& .file.test::before': {
          content: `url('https://github.com/vscode-icons/vscode-icons/raw/master/icons/file_type_reacttemplate.svg')`,
        },
        '& .file.json::before': {
          content: `url('https://github.com/vscode-icons/vscode-icons/raw/master/icons/file_type_json.svg')`,
        },
        '& .file.svg::before': {
          content: `url('https://github.com/vscode-icons/vscode-icons/raw/master/icons/file_type_svg.svg')`,
        },
      },
    },
    // 'div[class*="mdc-select__menu"]': {
    //   width: '20%',
    //   zIndex: 100,
    // },
  }),
);

// content: 'TS';
// color: rgb(81, 154, 186);
// font-weight: bold;
// margin-right: 10px;
